import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { QueryKeys } from './queryKeys';
import { getTollingAdminAccess } from 'utils/api';

export const useTollingAdminAccessQuery = () => {
  return useQuery({
    queryKey: [QueryKeys.tollingAdminAccess],
    queryFn: async () => {
      const data = await getTollingAdminAccess();
      return data;
    },
    staleTime: 1 * 1000 * 60,
    gcTime: 365 * 24 * 60 * 60 * 1000,
    refetchInterval: 1 * 1000 * 60,
    refetchOnWindowFocus: 'always',
    refetchOnMount: 'always',
    refetchOnReconnect: 'always',
    notifyOnChangeProps: ['data'],
    placeholderData: keepPreviousData,
  });
};
